export default {
  USER_ID: 'user_OwIdXkxQUL86Ll0D6NAY4',
  TEMPLATE_ID: 'template_3pb399p'
}